import {
  type SupportPageLangKey,
  supportPageLangMap,
} from '@/constants/localeMapping';

export const getSupportPageLang = (lang: SupportPageLangKey) => {
  return supportPageLangMap[lang] || supportPageLangMap.en;
};
